import { useEffect } from "react";

import { useAttachmentBlocker } from "./useAttachmentBlocker";

/**
 * Hook to prevent navigation away from the page when attachments are processing
 */
export const useAttachmentProtection = () => {
  const { hasIncompleteAttachments } = useAttachmentBlocker();

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (hasIncompleteAttachments) {
        event.preventDefault();
        event.returnValue =
          "You have attachments that are still processing. Are you sure you want to leave?";
        return event.returnValue;
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasIncompleteAttachments]);

  return {
    hasIncompleteAttachments,
  };
};
